
const workshops = {
    id: '2158f81c-7f7c-4e09-9f8c-dc67b090de4a',
    section: {title: 'Workshops'},
    viewClass: 'Workshop',
    items: [
        {
            id: 'ad0e988b-deab-487d-aec4-a5a3eb0d8d1b',
            day: 'Sunday, March 24, 2019',
            time: '11am-2pm',
            location: 'Topanga, CA',
            title: 'Indigo Dyeing and Custom Fragrance Blending',
            subtitle: 'A Creative Sundays Workshop',
            slug: 'indigo-dyeing-and-custom-fragrance-blending',
            link: 'https://www.hilarylhahn.com/store/p19/natural-bundle-dyeing-aromatherapy-retreat.html',
        },
        {
            id: 'e5b40b26-322a-4b8f-9892-83c6b7200a19',
            day: 'Friday, May 10, 2019',
            time: '6pm-9pm',
            location: 'Miracle Mile, CA',
            title: 'Botanical Bundle Dyeing and Herbal Bath Salts & Body Scrubs',
            subtitle: 'A Makers Workshop',
            slug: 'botanical-bundle-dyeing-and-herbal-bath-salts-body-scrubs',
            link: 'https://www.hilarylhahn.com/store/p46/Botanical_Bundle_Dye___Herbal_Bath_Salts_and_Scrubs_.html',
        },
        {
            id: 'b509221b-59af-47a4-8505-4a8db07f1242',
            day: 'June, 2019, Multiple Dates TBA',
            time: '11:30am-3:30pm',
            location: 'Cherry Valley, CA',
            title: '123 Farms Annual Lavender Festival',
            subtitle: 'Custom Aromatherapy Blends Workshops',
            slug: '123-farms-annual-lavender-festival',
            link: 'http://www.hsresort.com/thelavenderfestival/',
        }
    ]
}

const products = {
    id: 'e2a03092-9f7f-4a01-85dd-21b530d3549a',
    section: {title: 'Products'},
    viewClass: 'Product',
    items: [
        {
            id: '822f39db-a3db-4006-b525-bba8103fc461',
            image: 'IMG_20190130_112251757.jpg',
            slug: 'cocoa-rose-everywhere-balm',
            name: 'Cocoa Rose Everywhere Balm',
        },
        {
            id: '421776cd-95d0-4d47-8982-89ee54b7e8a8',
            image: 'IMG_20190130_112120637.jpg',
            slug: 'honey-jasmine-everywhere-balm',
            name: 'Honey Jasmine Everywhere Balm',
        },
        {
            id: '9afe100e-8f80-4162-acdd-e21fc6f60b2a',
            image: 'IMG_20190130_112214741.jpg',
            slug: 'rose-heart-everywhere-balm',
            name: 'Rose Heart Everywhere Balm',
        },
        {
            id: 'd6118faa-7dbe-45ed-96b0-3132e7be8aa1',
            image: 'IMG_20190130_112812791.jpg',
            slug: 'lumi-oil-fragrance-blend',
            name: 'Lumi Oil (Fragrance Blend)',
        },
        {
            id: '152fe519-5912-45f7-90bc-6518d7686dcf',
            image: 'IMG_20190130_112850853.jpg',
            slug: 'atchoo-seasonal-allergy-blend',
            name: 'Atchoo Seasonal Allergy Blend',
        },
        {
            id: '6701b0aa-51ad-4b52-a4d3-732d2e9007fb',
            image: 'IMG_20190130_112511524.jpg',
            slug: 'face-serum-1',
            name: 'Face Serum #1',
        },
        {
            id: 'bfc6a6ac-0fe8-4378-be8f-5615aff41820',
            image: 'IMG_20190130_112554735.jpg',
            slug: 'nyla-face-serum',
            name: 'Nyla Face Serum',
        },
        {
            id: '77c4fe7c-71a5-4c99-9d0b-fe2373c6e41a',
            image: 'IMG_20190130_113336908.jpg',
            slug: 'elderberry-syrup',
            name: 'Elderberry Syrup',
        },
        {
            id: '7b74130d-e714-41a6-9c7c-f05400573b8f',
            image: 'IMG_20190130_112416980.jpg',
            slug: 'melissa-tincture',
            name: 'Melissa Tincture',
        },
        {
            id: 'bea4eb8e-fad7-497f-8ffd-0697bb79171a',
            image: 'IMG_20190130_112725964.jpg',
            slug: 'organic-rose-water',
            name: 'Organic Rose Water',
        },
        {
            id: 'eda6d69c-4f90-4dc0-a49a-11d980d2e903',
            image: 'IMG_20190130_113615149.jpg',
            slug: 'custom-aromatherapy-blends',
            name: 'Custom Aromatherapy Blends',
        },
        {
            id: '0fb9be25-f58b-40cc-b227-5388cb474b7c',
            image: 'IMG_20190130_112021603.jpg',
            slug: 'diy-balm-kit',
            name: 'DIY Balm Kit',
        }
    ]
}
  
const consultations = {
    id: '73e782dc-f5bb-4bb4-8939-b847362a6b5b',
    section: {title: 'Consultations'}
}
  
const about = {
    id: '4b6c22b6-a046-4a87-a570-00efe0f507a2',
    section: {title: 'About'},
    viewClass: 'About',
    items: [
        {
            id: '72d70884-3103-4d1d-be87-652c2b9c5892',
            p: `We started this small family business in our kitchen in 2015, with a toddler in tow and a need to find zero-toxin, plant-based health and beauty products where we could pronounce and recognize all of the ingredients. I made only the products that I wanted to use myself and re-created the ones I loved best, and that's still my mantra today. I make every small batch by hand, and if I don't love it, you won't find it here. I source all of my ingredients from the highest quality, sustainable, ethical companies. `,
        },
        {
            id: 'bd9589ab-1da4-42a0-a499-dd3410d8087a',
            p: `As a Certified Aromatherapist and MA Education, it's my greatest joy to help my clients learn how to use aromatic products effectively and safely. Please message me with any questions. I'd love to speak with you about a Custom Consultation or creating a Workshop for your next event.`,
        },
        {
            id: 'f74de0fa-45de-4dd1-bd86-1e8c223dd2e8',
            p: `20% of all sales are used toward supporting social justice, environmental protection and humanitarian issues, including supporting small businesses run by women and POC.`,
        }
    ]
}

const sections = [
    products,
    workshops,
    consultations,
    about,
]
  
const footer = {
    fb: "https://www.facebook.com/ArtOfEssentials",
    instagram: "https://www.instagram.com/flinaromatherapy",
    email: "flin.art@gmail.com",
}

const appData = {
    heading: 'Art of Essentials',
    tagLine: 'Aromatherapy inspired by traditional plant medicine',
    sections: sections,
    footer: footer,
}

export default appData;



// WEBPACK FOOTER //
// ./src/app-data.js